import {
  commonUtil,
  countryUtil,
  countryCallingCodeUtil,
  stockAdjustUtil
} from '@/util'

const areaNameList = [
  'storage.storage_stock-adjust-info',
  'common.input_recipient-info'
]

const interfaceObj = {
  title: '',
  postalCode: '',
  address: '',
  phone: ''
}

function setRegisterInfo(clientData) {
  const register = clientData.client
  // return [register.invoiceInfo, register.receiverInfo]

  const registerInvoice = register.invoiceInfo
  const invoiceInfo = {
    ...interfaceObj,
    title: areaNameList[0],
    adjustDate: registerInvoice.storageMoveDate,
    trackingNumber: registerInvoice.trackingNumber,
    adjustReason: registerInvoice.storageAdjustReason.label,
    target: registerInvoice.storageAdjustReasonTarget
  }

  const registerReceiver = register.receiverInfo
  const receiverInfo = {
    title: areaNameList[1],
    name: commonUtil.getSeparateWordsBySpace([registerReceiver.fullName]),
    postalCode: commonUtil.formatPostalCode(
      registerReceiver.postalCode,
      registerReceiver.country.value
    ),
    address:
      countryUtil.getRegionInfo(
        registerReceiver.country.value,
        commonUtil.getRegionValue(registerReceiver.region)
      ).label +
      commonUtil.getSeparateWordsBySpace([
        registerReceiver.address1,
        registerReceiver.address2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(registerReceiver.phone.phoneNumber, ''),
      registerReceiver.phone.countryCode.value
    )
  }

  return [invoiceInfo, receiverInfo]
}

function setHistoryInfo(history) {
  const invoiceInfo = {
    title: areaNameList[0],
    adjustDate: history.stockAdjustDate,
    trackingNumber: history.trackingNumber,
    adjustReason: stockAdjustUtil.getAdjustReasonById(history.adjustReasonId)
      .name,
    target: history.target
  }

  const receiverInfo = {
    title: areaNameList[1],
    name: history.recipientName,
    postalCode: commonUtil.formatPostalCode(
      history.recipientPostalCode,
      history.recipientCountryId
    ),
    address:
      countryUtil.getRegionInfo(
        history.recipientCountryId,
        commonUtil.getRegionValue(history.recipientRegionId)
      ).label +
      commonUtil.getSeparateWordsBySpace([
        history.recipientAddress1,
        history.recipientAddress2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(history.recipientPhoneNumber, ''),
      history.recipientPhoneNumberCountryId
    )
  }

  return [invoiceInfo, receiverInfo]
}

export default { setRegisterInfo, setHistoryInfo }
